/* eslint-disable react/prop-types */
import React from "react";
import { Input } from "@nextui-org/input";

const CustomInput = ({
  className,
  label,
  labelPlacement,
  type,
  endContent,
  isDisabled,
  value,
  onChange,
  error,
  errorMessage,
  name,
  placeholder,
  variant,
}) => {
  return (
    <div className="flex flex-col">
      <Input
        name={name}
        labelPlacement={labelPlacement ?? "outside"}
        type={type ?? ""}
        step="any"
        placeholder={isDisabled ? `` : placeholder ?? `โปรดกรอก${label}...`}
        label={label}
        value={value}
        variant={variant ?? "underlined"}
        isDisabled={isDisabled}
        isInvalid={error}
        classNames={{
          inputWrapper: [
            isDisabled
              ? [
                  "border-none",
                  "bg-transparent",
                  "shadow-none",
                  "!border-b-0",
                  "before:border-none",
                  "after:border-none",
                ]
              : [
                  "data-[hover=true]:bg-transparent",
                  error && [
                    "group-data-[focus=true]:after:!bg-red-500",
                    "group-data-[invalid=true]:after:!bg-red-500",
                    "group-data-[invalid=true]:before:!bg-red-500",
                    "group-data-[focus=true]:before:!bg-red-500",
                    "!border-red-500",
                  ],
                ],
          ],
          label: [error && "text-red-500"],
          input: [
            type === "number" && [
              "appearance-none",
              "[&::-webkit-outer-spin-button]:appearance-none",
              "[&::-webkit-inner-spin-button]:appearance-none",
              "[&::-webkit-inner-spin-button]:m-0",
            ],
            error && "placeholder:text-red-500",
          ],
          base: [
            "data-[disabled=true]:opacity-100",
            isDisabled ? "pointer-events-none" : "",
          ],
        }}
        {...(type === "number" && {
          min: 0,
          onKeyDown: (e) => {
            if (e.key === "-" || e.key === "e") {
              e.preventDefault();
            }
          },
        })}
        className={`${className}`}
        endContent={endContent}
        onChange={onChange}
      />
      {error && <p className="text-red-500 text-sm pt-2">{errorMessage}</p>}
    </div>
  );
};

export default CustomInput;
